import React, { memo, MouseEvent, useContext } from 'react'
import { SortArrowToggle } from 'transfix-ui/components/SortArrowToggle'
import { $enum } from 'ts-enum-util'
import { FeatureFlagsContext } from 'utils/context/FeatureFlagsContext'
import { SHIPPER_RATES_COLUMNS, SORT_FIELD, SORT_ORDER } from 'apps/rms/types/shipperRates'
import { TableHead, TableRow, TableCell } from 'transfix-ui'

interface IShipperRatesHeaderProps {
  sortField?: SORT_FIELD
  sortOrder?: SORT_ORDER
  onSortingChange: (sortField: SORT_FIELD) => void
}

export const ShipperRatesTableHeader = memo<IShipperRatesHeaderProps>(
  ({ onSortingChange, sortField, sortOrder }) => {
    const sortHandler = (e: MouseEvent<HTMLButtonElement>) =>
      onSortingChange(e.currentTarget.value as SORT_FIELD)
    const { getFlag } = useContext(FeatureFlagsContext)
    const { enabled: mpRmsRepricedRates } = getFlag('mpRmsRepricedRates')
    return (
      <TableHead>
        <TableRow tableCellType='th'>
          {Object.entries(SHIPPER_RATES_COLUMNS)
            .filter(
              ([, value]) => value !== SHIPPER_RATES_COLUMNS.isRepricedRate || mpRmsRepricedRates
            )
            .map(([key, value]) => (
              <TableCell dataTest={`${key}-column-header`} key={`${key}-column-header`}>
                {key in SORT_FIELD ? (
                  <button
                    className='sort'
                    value={$enum(SORT_FIELD).getValueOrDefault(key)}
                    onClick={sortHandler}>
                    {value}{' '}
                    <SortArrowToggle
                      direction={
                        sortField === $enum(SORT_FIELD).getValueOrDefault(key)
                          ? sortOrder
                          : undefined
                      }
                    />
                  </button>
                ) : (
                  value
                )}
              </TableCell>
            ))}
          <TableCell>&nbsp;</TableCell>
        </TableRow>
      </TableHead>
    )
  }
)
